import React from "react";

import CsvImportModal from "Components/Common/CsvImport/CsvImportModal";
import { importLOA } from "common/services/govt-requests.service";
import { LOA_IMPORT_FIELDS, mapLoaImportRow } from "./loaImportConfig";

const LOAImportModal: React.FC<{
  isOpen: boolean;
  toggle: () => void;
  onImported?: () => void;
}> = ({ isOpen, toggle, onImported }) => (
  <CsvImportModal
    isOpen={isOpen}
    toggle={toggle}
    title="Import LOAs"
    subtitle="Upload a CSV file to bulk-import letters of agreement"
    icon="ri-file-list-3-line"
    fields={LOA_IMPORT_FIELDS}
    mapRow={mapLoaImportRow}
    importRecords={importLOA}
    templatePath={`${process.env.PUBLIC_URL}/templates/loas_import_template.csv`}
    templateFileName="loas_import_template.csv"
    failedFileName="Failed_LOAs_Import.csv"
    recordLabel="LOA"
    onImported={onImported}
  />
);

export default LOAImportModal;
